/* eslint-disable react/jsx-props-no-spreading */
// NB!: Don't include it in atoms/index.js to not include tinymce dependency on each page
import 'tinymce/tinymce';
import './tooltipPlugin';
import 'tinymce/themes/silver';
import './skins/worldathletics.less';

import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';

import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

import SelectMedia from '@organisms/AddMediaModal/SelectMedia';
import { MEDIA_TYPE } from '@api/media/constants';
import Collapse from '@atoms/Collapse';
import { getSrc } from '@utils/media';

import contentStyle from './contentStyle';
import ShortcodeModal from './ShortcodeModal';
import CampaignModal from './CampaignModal';
import { configureFocus, imagesUploadHandler } from './utils';
import { TOOLBAR_ITEM, DEFAULT_TOOLBAR, PLUGINS } from './constants';
import s from './styles.module.less';

const RichTextEditor = ({
  name,
  id,
  value,
  onChange,
  height = 300,
  toolbarItems = DEFAULT_TOOLBAR,
  exclude: omit = [],
  include = [],
}) => {
  const tinymceRef = React.useRef(null);
  const shortcodes = ShortcodeModal.useShortcodes();
  const campaign = CampaignModal.useCampaign();

  const toolbar = React.useMemo(() => [...toolbarItems, ...include].filter((item) => !omit.includes(item)).join(' '), [
    omit,
    include,
    toolbarItems,
  ]);

  const handleSelect = (selectedMedia) => {
    if (!tinymceRef?.current?.editor) return;

    const src = getSrc({ media: selectedMedia });
    tinymceRef.current.editor.insertContent(
      `<div>
        <img src="${src}" alt="${selectedMedia?.title}" style="max-width:900px;width:100%;display:block;" />
        <p style="font-size:0.9em;color:#B2B2B2;text-align:right;margin:-15px 0 0px;">
          ${selectedMedia?.title} ${selectedMedia?.copyright ? `(© ${selectedMedia.copyright})` : ''}
        </p>
      </div>
      <br />`,
    );
  };

  return (
    <>
      <Editor
        textareaName={name}
        id={id}
        plugins={PLUGINS}
        toolbar={toolbar}
        value={value}
        ref={tinymceRef}
        init={{
          skin: false,
          content_style: contentStyle,
          height,
          images_upload_handler: imagesUploadHandler,
          menubar: false,
          statusbar: false,
          setup: (editor) => {
            configureFocus({ editor });
            shortcodes.configure({ editor });
            campaign.configure({ editor });
          },
        }}
        onEditorChange={onChange}
      />
      <Collapse className={s.collapse}>
        <Collapse.Panel header="Select Media Image" className={s.collapseHeader}>
          <SelectMedia type={MEDIA_TYPE.IMAGE} onSelect={handleSelect} className={s.collapseContent} />
        </Collapse.Panel>
      </Collapse>
      <ShortcodeModal
        {...shortcodes.modal}
        type={shortcodes.type}
        onSubmit={(str) => tinymceRef.current?.editor.insertContent(str)}
      />
      <CampaignModal
        {...campaign.modal}
        type={campaign.type}
        onSubmit={(str) => tinymceRef.current?.editor.insertContent(str)}
      />
    </>
  );
};

RichTextEditor.TOOLBAR_ITEM = TOOLBAR_ITEM;

export default RichTextEditor;
